"use client";

import { useState } from "react";
import ICON_ARROW_DOWN_MOBILE_BLACK from "@/assets/images/Arrow_drop_down.svg";
import { displayValue, StatusComponent } from "../OtherBetsDropdown";
import "../OtherBetsDropdown/index.scss";


const GoalOddEvenOdds = ({ goalOddEvenOdds }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const odds =
    Array.isArray(goalOddEvenOdds) && goalOddEvenOdds.length > 0
      ? goalOddEvenOdds[0]
      : {};

  return (
    <div className="goal-odd-even-odds-container">
      <div className="bg-[var(--theme-bg)] flex justify-between items-center @max-sm:h-5 @max-sm:w-full rounded-t-sm @max-sm:px-3 @lg:h-[2rem] @lg:mb-1 @lg:py-1 @lg:rounded-md">
        <div
          className="flex flex-wrap items-center gap-1 hover:cursor-pointer"
          onClick={() => handleCollapse()}
        >
         <>
            <img
              alt="Net88"
              src={ICON_ARROW_DOWN_MOBILE_BLACK}
              width={20}
              height={20}
              className={`w-6 h-6 transition-transform duration-300 ${isCollapsed ? "rotate-180" : ""}`}
            />
          </>
          <span className="@max-sm:font-montserrat font-semibold text-sm text-[var(--theme-text)] w-[7.75rem] ">Odd/Even</span>
        </div>
      </div>
      <div
        id="collapse"
        className={`bg-[var(--theme-foreground)] rounded-br-lg rounded-bl-lg ${
          isCollapsed ? "hidden" : "visible"
        }`}
      >
        <div className="flex items-center justify-between gap-[1px] @lg:gap-1 text-xxs font-normal">
          <div className="flex-1 flex flex-col text-center">
            <p className="bg-[var(--theme-foreground)] @max-sm:text-xxs @max-sm:font-medium pt-[2px]">Odd</p>
            <p className="flex items-center justify-center gap-1 bg-[var(--theme-bg)]">
              <span className={`flex items-center justify-center gap-1 inline-block bg-[var(--theme-foreground)] w-[82px] my-2 rounded-[25px] text-center h-[20px]`}>
                {displayValue(odds?.single)}
                <StatusComponent trend={odds?.initialSingleTrend} />
              </span>
            </p>
          </div>

          <div className="flex-1 flex flex-col text-center">
            <p className="bg-[var(--theme-foreground)] @max-sm:text-xxs @max-sm:font-medium pt-[2px]">Even</p>
            <p className="flex items-center justify-center gap-1 bg-[var(--theme-bg)]">
              <span className="flex items-center justify-center gap-1 inline-block bg-[var(--theme-foreground)] w-[82px] my-2 py-[3px] rounded-[25px] text-center h-[20px]">
                {displayValue(odds?.double)}
                <StatusComponent trend={odds?.initialDoubleTrend} />
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoalOddEvenOdds;